import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import LinksReplacer from '../ui/LinksReplacer'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsCompItem extends SettingsItemForm {

  modelName = 'comp'

  showRequ = e => {
    e.preventDefault();
    e.stopPropagation();
    this.context.router.push('/sets_requ?comp_id='+this.props.data.comp_id);
  }

  updateSrvgs = e => {
    this.setState({
      data:{
        ...this.state.data,
        comp_srvg_ids: e
      }
    });
  }

  updateCtype = e => {
    this.setState({
      data:{
        ...this.state.data,
        comp_ctype_id: e ? e.value : 0
      }
    });
  }

  render() {
    const { srvgs, data, ctypes } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    const srvgIdArray = data.comp_srvg_ids.split(',');
    srvgs[''] = '';
    const srvgDescArray = srvgIdArray.map(el => {
      if (srvgs[el] && srvgs[el].hasOwnProperty('srvg_desc')) {
        return srvgs[el].srvg_desc;
      }
      return '';
    });

    var srvgsOpt = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key) && (srvgs[key].srvg_active === 1
        || srvgIdArray[key])) {
        srvgsOpt.push({value:key,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    var ctypesOpt = [];
    for (let key in ctypes){
      if(ctypes.hasOwnProperty(key) && (ctypes[key].ctype_active === 1
        || ctypes[key].ctype_id === data.comp_ctype_id)) {
        ctypesOpt.push({value:key,label:ctypes[key].ctype_desc});
      }
    }
    ctypesOpt.sort(sortOpts);

    if(this.state.editing){
      return(
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.comp_desc}
                name="comp_desc"
                onChange={this.updateInput}
                placeholder="Краткое название"
                autoFocus
              />
            </div>
            <div className="form-group">
              <Select
                options={ctypesOpt}
                value={nData.comp_ctype_id}
                onChange={this.updateCtype}
                placeholder="Тип"
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
              {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            </div>
          </td>
          <td>
            <div className="form-group">
              <Select
                clearable={false}
                options={srvgsOpt}
                value={nData.comp_srvg_ids}
                onChange={this.updateSrvgs}
                placeholder="Услуги"
                simpleValue
                multi
              />
            </div>
          </td>
          <td>
            <textarea type="text"
              rows="2"
              className="form-control"
              value={nData.comp_note}
              onChange={this.updateInput}
              name="comp_note"
              placeholder="Описание"
            />
            <label>
              Клиент{" "}
              <input type="checkbox" checked={nData.comp_order}
                name="comp_order" onChange={this.handleChBox} />
            </label><br />
            <label>
              Подрядчик{" "}
              <input type="checkbox" checked={nData.comp_cost}
                name="comp_cost" onChange={this.handleChBox} />
            </label><br />
            <label>
              Издержки{" "}
              <input type="checkbox" checked={nData.comp_expense}
                name="comp_expense" onChange={this.handleChBox} />
            </label><br />
            <label>
              Сотрудник{" "}
              <input type="checkbox" checked={nData.comp_empl}
                name="comp_empl" onChange={this.handleChBox} />
            </label>
          </td>
          <td>
            <textarea type="text"
              rows="4"
              className="form-control"
              value={nData.comp_addr}
              name="comp_addr"
              onChange={this.updateInput}
              placeholder="Адрес компании"
            />
          </td>
          <td colSpan="2">
            <input type="text"
              className="form-control"
              value={nData.comp_tel}
              onChange={this.updateInput}
              name="comp_tel"
              placeholder="Телефон"
            />
            <input type="text"
              className="form-control"
              value={nData.comp_email}
              onChange={this.updateInput}
              name="comp_email"
              placeholder="Email"
            />
            <input type="text"
              className="form-control"
              value={nData.comp_long}
              name="comp_long"
              onChange={this.updateInput}
              placeholder="Название для печатных форм"
            />
          </td>
        </tr>
      );
    }
    else{
      let ctypeDesc = ctypes[data.comp_ctype_id] ? ' (' + ctypes[data.comp_ctype_id].ctype_desc + ')' : '';
      return (
        <tr className="show-hover-container" onClick={this.startEditing}>
          <td>
            <button type="button" className="btn btn-info btn-xs show-hover"
              onClick={this.showRequ}>
              Рекв.
            </button>{" "+data.comp_desc + ctypeDesc}
          </td>
          <td>{srvgDescArray.join(', ')}</td>
          <td>
            <LinksReplacer
              text={data.comp_note}
            />
          </td>
          <td>{data.comp_addr}</td>
          <td>{data.comp_tel} {data.comp_email}</td>
          <td>{data.comp_long}</td>
        </tr>
      );
    }

  }
}

SetsCompItem.contextTypes = {
  router: PropTypes.object.isRequired
}

export default connect(null, { editSets })(SetsCompItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsCompItem.js